import useSegment from "./useSegment";
import { pageData } from 'Data';

const usePageData = ()=>{
  const segment = useSegment();
  if(pageData && pageData.length) {
    const data = pageData.find((item) => item.slug === segment)
    const {backgroundStyle} = data || {};

    return {
      data, 
      backgroundStyle
    }

  } else {
    return {};
  }
}

export default usePageData;